let debugEnabled = false;

export function setDebug(on: boolean): void {
	debugEnabled = !!on;
}

export function isDebug(): boolean {
	return debugEnabled;
}

export function log(...args: unknown[]): void {
	if (debugEnabled && typeof console !== 'undefined') {
		// eslint-disable-next-line no-console
		console.log('[emblue]', ...args);
	}
}

export function warn(...args: unknown[]): void {
	if (typeof console !== 'undefined') {
		// eslint-disable-next-line no-console
		console.warn('[emblue]', ...args);
	}
}
